import axios from "axios";
import { BACKEND_URL } from "../../config/api";
import { ExchangeRate } from "../../types/features/administration/Setting";


export const exchangeRateService = {
  // Récupérer tous les taux
  async getAllRates(token: string): Promise<ExchangeRate[]> {
    try {
      const response = await axios.get(`${BACKEND_URL}/exchange-rate/get_all_rate`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data?.data?.rates || [];
    } catch (error) {
      console.error("Erreur lors de la récupération des taux:", error);
      throw error;
    }
  },

  // Récupérer un taux spécifique
  async getRate(fromCurrency: string, toCurrency: string, token: string): Promise<ExchangeRate> {
    try {
      const response = await axios.get(
        `${BACKEND_URL}/exchange-rate/get_all_rate?from_currency=${fromCurrency}&to_currency=${toCurrency}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data?.data?.rate;
    } catch (error) {
      console.error("Erreur lors de la récupération du taux:", error);
      throw error;
    }
  },

  // Récupérer le taux actif
  async getActiveRate(token: string): Promise<ExchangeRate> {
    try {
      const response = await axios.get(`${BACKEND_URL}/exchange-rate/get_active_rate`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data?.data?.rate;
    } catch (error) {
      console.error("Erreur lors de la récupération du taux actif:", error);
      throw error;
    }
  },

  // Créer un nouveau taux
  async createRate(rate: Omit<ExchangeRate, "id" | "created_at" | "updated_at">, token: string): Promise<ExchangeRate> {
    try {
      const response = await axios.post(`${BACKEND_URL}/exchange-rate/create_rate`, rate, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      return response.data?.data?.rate;
    } catch (error) {
      console.error("Erreur lors de la création du taux:", error);
      throw error;
    }
  },

  // Mettre à jour un taux
  async updateRate(
    fromCurrency: string,
    toCurrency: string,
    updates: { rate?: number; status?: "ACTIVE" | "INACTIVE" },
    token: string
  ): Promise<ExchangeRate> {
    try {
      const response = await axios.put(
        `${BACKEND_URL}/exchange-rate/update_rate?from_currency=${fromCurrency}&to_currency=${toCurrency}`,
        updates,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      return response.data?.data?.rate;
    } catch (error) {
      console.error("Erreur lors de la mise à jour du taux:", error);
      throw error;
    }
  },

  // Supprimer un taux
  async deleteRate(fromCurrency: string, toCurrency: string, token: string): Promise<void> {
    try {
      await axios.delete(
        `${BACKEND_URL}/exchange-rate/delete_rate?from_currency=${fromCurrency}&to_currency=${toCurrency}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    } catch (error) {
      console.error("Erreur lors de la suppression du taux:", error);
      throw error;
    }
  },
};
